/**
 *
 * WCCOfferAdditionalTimings
 *
 */

import React from "react";
import PropTypes from "prop-types";
import sortBy from "lodash/sortBy";
import styled from "styled-components";
import { IntlPropType, getTimeOfDay } from "root/libs/core-libs/src";
import { DhlText } from "@dhl-official/react-library";

const COPY_ID_PREFIX = "WCCOfferAdditionalTimings";

const StyledAdditionalDeliveryText = styled(DhlText)`
  & > *:is(p, span) {
    font-size: ${(props) => (props.isMultiBU ? "1.2rem" : "1.5rem")} !important;
    font-weight: ${(props) => (props.isMultiBU ? "400" : "200")} !important;
    margin-bottom: 1.4rem;
  }
`;

export default function WCCOfferAdditionalTimings({
  intl,
  offerIndex,
  offerId,
  offersByPurchaseMethod,
  useFallback,
  isMultiBU,
}) {
  function getRestOfTheAvailableDeliveryTimes() {
    const offersExcludingSelected = offersByPurchaseMethod.filter(
      (obj) => obj.id !== offerId
    );
    return sortBy(offersExcludingSelected, "estimatedDeliveryTime");
  }

  // If we need to add the 4 time options, this is the place to do it:
  function createStringMessage() {
    if (useFallback) {
      return intl.formatMessage({ id: `${COPY_ID_PREFIX}.fallback` });
    }
    // TODO: useFallback in both places where the component is rendered is set
    // to true. in that case, check to make sure this code block is still needed.
    const remainingOffers = getRestOfTheAvailableDeliveryTimes();
    return intl.formatMessage(
      { id: `${COPY_ID_PREFIX}.text` },
      {
        slot1:
          remainingOffers[0]?.estimatedDeliveryTime &&
          getTimeOfDay(
            intl,
            remainingOffers[0]?.estimatedDeliveryTime,
            "",
            true
          ),
        slot2:
          remainingOffers[1]?.estimatedDeliveryTime &&
          getTimeOfDay(
            intl,
            remainingOffers[1]?.estimatedDeliveryTime,
            "",
            true
          ),
      }
    );
  }

  return (
    <StyledAdditionalDeliveryText
      id={`wcc-offer-card-additional-timings-${offerIndex}`}
      dataTestid={`wcc-offer-card-additional-timings-${offerIndex}`}
      isParagraph
      isMultiBU={isMultiBU}
    >
      {createStringMessage()}
    </StyledAdditionalDeliveryText>
  );
}

WCCOfferAdditionalTimings.propTypes = {
  /** Internationalization library */
  intl: IntlPropType.isRequired,
  /** The index of the offer */
  offerIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  offerId: PropTypes.string,
  offersByPurchaseMethod: PropTypes.array,
  useFallback: PropTypes.bool,
  isMultiBU: PropTypes.bool,
};
